var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.543 6.189A4.271 4.271 0 016 8.5a4.271 4.271 0 01-3.543-2.311A5.976 5.976 0 00.138 9.726a.5.5 0 00.206.518 9.987 9.987 0 0011.312 0 .5.5 0 00.206-.518 5.976 5.976 0 00-2.319-3.537z",
    fill: "#797584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0a3 3 0 00-3 3c0 1.611 1.26 4 3 4s3-2.389 3-4a3 3 0 00-3-3z",
    fill: "#797584"
  })));
}

export default SvgUser;